import qs from 'qs'

export const queryEventsPage = (locale: QueryLocaleString) => {
  const query = qs.stringify(
    {
      locale: locale || 'en-US',
      fields: [
        'title',
        'richText'
      ],
      populate: {
        ...queryFragmentSeo
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `events-page?${query}`
}
